import { reflect } from '@effector/reflect'
import { useUnit } from 'effector-react'

import { modalOpener } from '@/shared/ui/modal'

import * as model from './model'
import { EmailConfirmDialog as View } from './view'

export const EmailConfirmDialog = {
    View: reflect({
        view: View,
        bind: {
            onBackButtonClick: model.backButtonClicked,
        },
    }),
    model,
}

model.showFx.use(
    modalOpener(EmailConfirmDialog.View, ({ email, onConfirm, $disableSubmitButton }) => ({
        email: email,
        onConfirmButtonClick: onConfirm,
        // biome-ignore lint/correctness/useHookAtTopLevel: TODO
        disableSubmitButton: $disableSubmitButton && useUnit($disableSubmitButton),
    }))
)
